// src/api/projectAndActivityApis.js
import axios from 'axios';

const BASE_URL = "https://ims.holdthechild.net/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

// Fetch all projects
export const fetchProjects = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/projects`, {
      headers: getAuthHeaders(),
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to fetch projects:', error);
    throw error;
  }
};

// Get activities by project ID
export const getActivitiesByProjectId = async (projectId) => {
  try {
    const response = await axios.get(`${BASE_URL}/activities/project/${projectId}`, {
      headers: getAuthHeaders(),
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching activities by project:", error);
    throw error;
  }
};